import _ from 'lodash'

export function getShortcut(row) {
  let shortcutId = null
  let leadFunction = null

  if (!_.isNull(row.proposal_id)) {
    shortcutId = row.proposal_id
    leadFunction = 'Lead Proposals'
  } else if (!_.isNull(row.rfi_id)) {
    shortcutId = row.rfi_id
    leadFunction = 'Lead RFIs'
  } else if (!_.isNull(row.estimate_id)) {
    shortcutId = row.estimate_id
    leadFunction = 'Lead Estimates'
  } else if (!_.isNull(row.contract_id)) {
    shortcutId = row.contract_id
    leadFunction = 'Lead Contracts'
  }

  return { shortcutId: shortcutId, leadFunction: leadFunction }
}



// WEBPACK FOOTER //
// ./src/util/leadFollowUps.js